import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AccommodationsReservationComponent } from 'src/app/accommodations/accommodations-reservation/accommodations-reservation.component';

@Component({
	selector: 'app-accommodations-products-rooms-availabilities',
	templateUrl: './accommodations-products-rooms-availabilities.component.html',
	styleUrls: ['./accommodations-products-rooms-availabilities.component.scss'],
})
export class AccommodationsProductsRoomsAvailabilitiesComponent {
	@Input() availability;

	constructor(private readonly dialog: MatDialog) {}

	protected openDetails(): void {
		if (this.availability.state !== 'R') {
			return;
		}
		const dialogRef = this.dialog
			.open(AccommodationsReservationComponent, {
				data: this.availability,
				disableClose: true,
			})
			.afterClosed()
			.subscribe((result) => {
				dialogRef.unsubscribe();
				if (!result) {
					return;
				}
			});
	}
}
